import React, {useContext, useState, useEffect, useRef} from 'react';
import {IProps, IState} from './types';
import C from '@assets/themes/colors';
import * as S from './styles';
import Button from '@components/Button';
import { BrandsContext } from '@utils/DOIgnition/BrandsContext';
import { storageAccountName, containerNameBrands } from '@storage/azure-storage-blob';
import IconButton from '@components/IconButton';
import OptionIcon from '@assets/icons/optionIcon';
import Menu from "../Menu"
import { isCloseToWhite } from '@utils/colors'

const Item:React.FC<IProps> = (props) => {
  const brandsContext = useContext(BrandsContext);
  const urlImage =`https://${storageAccountName}.blob.core.windows.net/${containerNameBrands}/${brandsContext.brandDetail?.brand?.id}/${props.section}/`;
  const [showBtn, setShowBtn] = useState<boolean>(false);
  const [openOptions, setOpenOptions] = useState(false);
  const [coordinates, setCoordinates] = useState({x: 0, y: 0});
  const lastAction : any|undefined = props.item?.actions ? props.item?.actions[props.item?.actions.length - 1] : undefined;
  const firstAction : any|undefined = props.item?.actions ? props.item?.actions[0] : undefined;
  const logoName = useRef() as React.MutableRefObject<HTMLInputElement>;
  const [tootltipName, showTooltipName]= useState<any|undefined>(undefined);

  const [reloadImage, setReloadImage] = useState<any>(Date.now());
  useEffect(() => {
    setReloadImage(Date.now());
  }, [props.item])

  const handleMouseSizes = (e: any) => {
    if (openOptions === false) setCoordinates({x: e.clientX, y: e.clientY});
  }

  const handleAction = (action: string) => {
    brandsContext.setBrandAction({section: props.section, action: action.toLowerCase(), element: props.item});
  }

  const tooltipValidate = (evt:any) => {
    const compare = logoName.current.scrollWidth > logoName.current.clientWidth;
    if(compare && !tootltipName) showTooltipName({x: evt.clientX+10, y: evt.clientY-10});
  };

  const getVehicleTags = () => {
    let tags: string[] = [];
    if (props.item.year) tags.push(props.item.year);
    if (props.item.make) tags.push(props.item.make);
    if (props.item.model) tags.push(props.item.model);
    if (props.item.trim) tags.push(props.item.trim);
    if (props.item.type) tags.push(props.item.type);
    return tags;
  }

  const getOptionsButton = (colors?: string) => {
    return <IconButton action={e => {if (!e.shiftKey) setOpenOptions(true)}} containerStyles={{
              transform: 'scale(0.7)',
              position: "absolute",
              bottom: props.type === "font" ? "3px" : "6px",
              right: `${colors ? -10 : 6}px`,
            }}
            hoverBackgroundColor={colors ? 'unset' : ''}>
              <OptionIcon
                style={{fillColor: colors 
                                  ? isCloseToWhite(colors) 
                                    ? C.GENERIC_GRAY : C.WHITE 
                                  : C.BLUE}}
              />
            </IconButton>
  }
 
  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.shiftKey && props.handleSelectedIndexes) {
      if (props.selected) {
        props.handleSelectedIndexes(props.index, 'REMOVE');
      } else {
        props.handleSelectedIndexes(props.index, 'ADD');
      }
    }
  }

  const handleContextMenu = (e: any) => {
    if (props.selected && props.setOpen) {
      e.preventDefault();
      props.setOpen(true);
    }
  }

  const getLabelTypes = (field: string) => {
    let text = "";
    props.item[field]?.forEach((element: any) => text = text==="" ? element.value : `${text}, ${element.value}`);
    return text;
  }

  return (
    <div id={`main-preview-component-${props.index}-${props.section}`}>
    {tootltipName && 
    <S.Tooltip 
    display={ tootltipName ? 'block':'none'}
    leftValue={`${tootltipName?.x}px`}
    topValue={`${tootltipName?.y}px`}>
          {props.type === "img" ? 
            `${props.item.name}.${props.item.format}` 
            : props.item.aliases.join('\n')
          }
    </S.Tooltip>}
    <S.Root 
      id={`preview-component-${props.index}-${props.section}`}
      selected={openOptions}
      multiSelected={props.selected}
      onMouseOver={(e)=> {setShowBtn(true); handleMouseSizes(e);}} 
      onMouseLeave={()=> setShowBtn(false)}
      smallContainer={props.type==="color"}
      fontContainer={props.type === "font"}
      onClick={handleClick}
      onContextMenu={handleContextMenu}
    >
        { props.type==="img" &&
        <>
            <S.ImgOutsideContainer>
            <S.ImgContainer height={86} src= {`${urlImage}${props.item.srcImage}${"TN"}?${reloadImage}`} onClick={()=>{}}/>
            </S.ImgOutsideContainer>
        </>}

        { props.type==="color" &&
        <>
          <S.Square multiSelected={props.selected} color={props.item.color} onClick={(e) => {}}>
          {showBtn && getOptionsButton(props.item.color)}
          </S.Square>
          <S.TextInfo> {props.item.color} </S.TextInfo>
        </>}
        
        { props.type==="font" &&
        <>
          <S.Font role="NewText" id={`font-${props.item.id}`} fontFamilyValue={props.item.id}>
            <S.FontMaxWidth>
              {props.item.name}
            </S.FontMaxWidth>
          </S.Font>
          {showBtn && getOptionsButton()}
        </>}
        
        {props.type!=="color" &&
        <S.Container
          fontContainer={props.type === "font"}
        >
          <S.TextInfo 
            ref={logoName}
            fontContainer={props.type === "font"}
          >
            {props.type === "img" ? 
              `${props.item.name}.${props.item.format}` 
              : props.item.name
            }
          </S.TextInfo>
          {(showBtn && props.type !== "font") && getOptionsButton()}
        </S.Container>
        }
    </S.Root>
    {openOptions &&
      <Menu
        open={openOptions}
        setOpen={setOpenOptions}
        coordinates={coordinates}
        labels={{
          name: props.item?.name ? props.item.name : props.item?.color ?  props.item?.color : '',
          oem: false,
          type: getLabelTypes("types"),
          themes: getLabelTypes("themes"),
          tags: (props.item.tags && props.item.tags.length>0) ? (props.item.tags):(props.item.year&&props.item.make?getVehicleTags():[]),
          lastEditedDate: lastAction ? new Intl.DateTimeFormat('en-US',{day:'2-digit', month:'2-digit', year:'2-digit'}).format(new Date(lastAction.date)) : '',
          elementName: props.section,
          aliases: props.item.aliases,
        }} 
        onActions={(action:string)=> handleAction(action)}
        brand={props.item}
        section={props.section}
      />
      }
    </div>
  );
}

export default Item;